import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import * as TableFilterActions from 'main/components/tableFilter/store/actions';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import TableFilter from 'main/components/tableFilter/TableFilter';

const styles = theme => ({
    layoutRoot: {},
});

class AssignmentList extends Component {

    constructor(props) {
        super(props);
        this.props.getAssignmentList('list');
    }

    componentWillUnmount = () => {
        this.props.setTableFilter(this.props.auth.user.data.auth_id, 'AssignmentList', this.props.filterList.filterColumns);
        this.props.clearFilterStore();
    }

    checkLockPermission = (row) => {
        const auth_id = this.props.auth.user.data.auth_id;
        const role = this.props.auth.user.role;
        if (row.IsLocked === 0) {
            return true
        }
        else {
            if (role === 'dev' || role === 'admin' || role === 'company') {
                return true
            }
            else if (role === 'instructor' && row.LockedByAuthID === auth_id) {
                return true
            }
        }
        return false
    }

    editAllow = (row) => {
        if (this.checkLockPermission(row)) {
            let tooltipContent = 'Edit';
            if (row.IsLocked === 1) {
                tooltipContent = <React.Fragment><div>Edit</div><div>(Locked)</div></React.Fragment>
            }
            return (
                <Tooltip title={tooltipContent}>
                    <IconButton
                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                        onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleRowClick('edit', row.assignment_id);
                        }}
                    >
                        <Icon>border_color</Icon>
                    </IconButton>
                </Tooltip>
            )
        }
        else {
            return (
                <Tooltip title="This assignment is locked">
                    <Icon style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }} >lock</Icon>
                </Tooltip>
            )
        }

    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            if (rowInfo.original.Active === 0) {
                return {
                    style: {
                        background: '#a85e59'
                    } 
                }
            }
        }
        return {};
    }

    checkFilterValueSaved = (column) => {
        const { table_filter } = this.props
        if (!table_filter['AssignmentList']) {
            return false
        }
        if (!table_filter['AssignmentList'].find(col => col.id === column)) {
            return false
        }

        else {
            return table_filter['AssignmentList'].find(col => col.id === column).value.filterValue
        }
    }

    handleRowClick(page_type, assignment_id) {
        this.props.history.push(`/assignment/${page_type}/${assignment_id}`);
    }

    render() {
        const { classes, table_page_size, assignmentList, table_sort, table_filter, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded || !this.props.assignmentListLoadedAfterSave || !this.props.listLoaded) return <React.Fragment>Loading...</React.Fragment>;
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type={"assignment"}
                        view_type={"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name={"assignment"}
                            view_type={"list"}
                            button_list={[
                                {
                                    display: "Add",
                                    type: "create",
                                    color: "primary",
                                    onClick: () => this.props.history.push("/assignment/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <Grid container style={{ height: '100%' }}>
                        <Grid item xs={9}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <ReactTable
                                    style={{ position: 'absolute' }}
                                    columns={[
                                        {
                                            Header: "Assignment Name",
                                            accessor: "AssignmentName",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.AssignmentName}
                                                    chars={20}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Assignment Description",
                                            accessor: "AssignmentDescription",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.AssignmentDescription}
                                                    chars={30}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Last Edit",
                                            accessor: "LastEditDate",
                                            maxWidth: 200,
                                        },
                                        {
                                            Header: "Actions",
                                            maxWidth: 100,
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <Tooltip title="Detail">
                                                        <IconButton
                                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.handleRowClick('detail', row.original.assignment_id);
                                                            }}
                                                        >
                                                            <Icon>library_books</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "assignment", "edit") ? null :
                                                        this.editAllow(row.original)
                                                    }
                                                </div>
                                            )
                                        }
                                    ]}
                                    data={this.props.filterList.filteredDataList}
                                    defaultPageSize={25}
                                    pageSize={table_page_size[table_name]}
                                    className="-striped -highlight"
                                    noDataText="No Assignments Found"
                                    defaultSorted={table_sort[table_name]}
                                    onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                                    filterable={false}
                                    defaultFiltered={table_filter[table_name]}
                                    // onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                                    onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                                    getTrProps={this.getTrProps}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={3} style={{ overflowY: 'auto', overflowX: 'hidden'}}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <TableFilter
                                    componentName={'AssignmentName'}
                                    defaultList={assignmentList}
                                    preloadValues={table_filter['AssignmentName'] ? true : false}
                                    columns={[
                                        {
                                            columnName: 'Assignment Name',
                                            column_id: 'AssignmentName',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('AssignmentName') || '',
                                            active: this.checkFilterValueSaved('AssignmentName') ? true : false
                                        },
                                        {
                                            columnName: 'Assignment Description',
                                            column_id: 'AssignmentDescription',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('AssignmentDescription') || '',
                                            active: this.checkFilterValueSaved('AssignmentDescription') ? true : false
                                        },
                                        {
                                            columnName: 'Active',
                                            column_id: 'Active',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            // value: Number(this.checkFilterValueSaved('Active')),
                                            value: this.checkFilterValueSaved('Active') ? Number(this.checkFilterValueSaved('Active')) : 2,
                                            // active: Number(this.checkFilterValueSaved('Active')) !== 0
                                            active: true
                                        },
                                        {
                                            columnName: 'On Calendar',
                                            column_id: 'on_calendar',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: Number(this.checkFilterValueSaved('on_calendar')),
                                            active: Number(this.checkFilterValueSaved('on_calendar')) !== 0
                                        },
                                        {
                                            columnName: 'Tags',
                                            column_id: 'Labels',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.assignmentListSearchable.labels,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Labels'),
                                            active: this.checkFilterValueSaved('Labels').length > 0
                                        },
                                        {
                                            columnName: 'Companies',
                                            column_id: 'Companies',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.assignmentListSearchable.companies,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Companies'),
                                            active: this.checkFilterValueSaved('Companies').length > 0
                                        },
                                        {
                                            columnName: 'Courses',
                                            column_id: 'Courses',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.assignmentListSearchable.courses,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Courses'),
                                            active: this.checkFilterValueSaved('Courses').length > 0
                                        },
                                        {
                                            columnName: 'Lessons',
                                            column_id: 'Lessons',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.assignmentListSearchable.lessons,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Lessons'),
                                            active: this.checkFilterValueSaved('Lessons').length > 0
                                        },
                                        // {
                                        //     columnName: 'Lessons',
                                        //     column_id: 'Lessons',
                                        //     columnType: 'array',
                                        //     filterType: 'array_search',
                                        //     searchableValues: this.props.assignmentListSearchable.lessons,
                                        //     switchVal: false,
                                        //     value: this.checkFilterValueSaved('Lessons'),
                                        //     active: this.checkFilterValueSaved('Lessons').length > 0
                                        // },
                                        // {
                                        //     columnName: 'Lessons',
                                        //     column_id: 'Lessons',
                                        //     columnType: 'array',
                                        //     filterType: 'array_search',
                                        //     searchableValues: this.props.assignmentListSearchable.lessons,
                                        //     switchVal: false,
                                        //     value: this.checkFilterValueSaved('Lessons'),
                                        //     active: this.checkFilterValueSaved('Lessons').length > 0
                                        // },
                                    ]}
                                />
                            </div>
                        </Grid>
                    </Grid>

                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssignmentList: Actions.getAssignmentList,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
        clearFilterStore: TableFilterActions.clearFilterStore,
        setTableFilter: TableFilterActions.saveTableFilter,
    }, dispatch);
}

function mapStateToProps({ assignmentApp, tableSort, auth, tableFilter }) {
    return {
        listLoaded: assignmentApp.assignments.listLoaded,
        assignmentList: assignmentApp.assignments.assignmentList,
        assignmentListLoadedAfterSave: assignmentApp.assignments.assignmentListLoadedAfterSave,
        assignmentListSearchable: assignmentApp.assignments.assignmentListSearchable,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        filterList: tableFilter,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignmentList)));


// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentList.js